import React from 'react'
import { ChakraProvider } from '@chakra-ui/react'
import { system } from '../theme'
import { ColorModeProvider } from '../components/ui/color-mode'
import { AuthProvider } from './auth/AuthContext'
import { Toaster } from '@/components/ui/toaster/toaster'

export function AppProviders({ children }: React.PropsWithChildren) {
  return (
    <ChakraProvider value={system}>
      <AuthProvider>
        <ColorModeProvider>{children}</ColorModeProvider>
      </AuthProvider>
      <Toaster />
    </ChakraProvider>
  )
}
